// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrows__wrapper___ItF14","sticky":"Arrows__sticky___7kVuX","right":"Arrows__right___6mO42","left":"Arrows__left___Zl3zr"};